/**
 * 管理者(admin)画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import RootView from '../views/admin/RootView.vue'
import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminUserAcademies from '../views/admin/AdminUserAcademies.vue'
import AdminAcademies from '../views/admin/AdminAcademies.vue'
import AdminNoticeList from '../views/admin/AdminNoticeList.vue'
import AdminNoticeRegist from '../views/admin/AdminNoticeRegist.vue'
import AdminNoticeDetail from '../views/admin/AdminNoticeDetail.vue'
import AdminNoticeEdit from '../views/admin/AdminNoticeEdit.vue'

/**
 * 管理者用ページ群
 */
const adminRoutes: Array<RouteConfig> = [
  // ルートアクセス時のリダイレクト処理
  {
    path: '/admin',
    name: 'AdminRoot',
    component: RootView,
  },
  // ログイン
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
  },
  // 塾管理者一覧
  {
    path: '/admin/academy/users',
    name: 'AdminAcademyUsers',
    component: AdminUserAcademies,
  },
  // 塾一覧
  {
    path: '/admin/academies',
    name: 'AdminAcademies',
    component: AdminAcademies,
  },
  // お知らせ一覧
  {
    path: '/admin/notice',
    name: 'AdminNoticeList',
    component: AdminNoticeList,
  },
  // お知らせ登録(URLの関係上、必ず詳細より上に設定する)
  {
    path: '/admin/notice/regist',
    name: 'AdminNoticeRegist',
    component: AdminNoticeRegist,
  },
  // お知らせ詳細
  {
    path: '/admin/notice/:id',
    name: 'AdminNoticeDetail',
    component: AdminNoticeDetail,
  },
  // お知らせ編集
  {
    path: '/admin/notice/:id/edit',
    name: 'AdminNoticeEdit',
    component: AdminNoticeEdit,
  },
]

export default adminRoutes
